import { ExamTests_ExamTestFragment } from 'generated/graphql'
import {
  formatKorDate,
  formatToCustomDate,
  parseAcquiredDate,
} from '@app.feature/exam/modules'

type TCalculateAgeFromTimestampFn = (
  birthdateTimestamp?: number | null,
) => string

type ParseTestResultDateParams = {
  dateList: Array<ExamTests_ExamTestFragment>
  testId: string
  formatType: 'kor' | 'slash'
}

type ParseTestResultDateFn = (params: ParseTestResultDateParams) => string

export const parseTestResultDate: ParseTestResultDateFn = (params) => {
  const { dateList, formatType, testId } = params
  const userTestDate = dateList.filter((date) => date.id === testId)[0]

  if (!userTestDate) {
    return ''
  }

  if (formatType === 'kor') {
    return formatKorDate(userTestDate.date)
  } else {
    return formatToCustomDate(userTestDate.date)
  }
}

/**
 * @desc 타임스탬프를 받아서 만 나이를 계산하여 반환합니다
 * @param birthdateTimestamp
 */
export const calculateAgeFromTimestamp: TCalculateAgeFromTimestampFn = (
  birthdateTimestamp,
) => {
  if (!birthdateTimestamp) return '-'

  const today = new Date()
  const birthDate = new Date(birthdateTimestamp)
  const date = parseAcquiredDate(birthdateTimestamp)

  const thisYearsBirthday = new Date(
    today.getFullYear(),
    birthDate.getMonth(),
    birthDate.getDate(),
  )

  const age =
    today.getFullYear() -
    birthDate.getFullYear() -
    (today < thisYearsBirthday ? 1 : 0) // 생일이 지났는지 여부에 따라 -1, 0

  return `${date} (${age}세)`
}
